import styled from "styled-components";

import ThemeInterface from "types/ThemeInterface";

export const Header = styled.div<{
  theme: ThemeInterface;
  $isContentVisible: boolean;
  headerBackgroundColor?: string;
}>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${({ theme, headerBackgroundColor }) =>
    headerBackgroundColor || theme.customTheme.palette.white.light};
  border-radius: 6px 6px 0 0;
  border-radius: ${({ $isContentVisible }) => ($isContentVisible ? "6px 6px 0 0" : "6px")};
  cursor: pointer;
  padding: 4px 0px;
`;

export const HeaderContentContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
`;

export const ArrowContainer = styled.div`
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const DropdownWrapper = styled.section<{ dropShadow?: boolean }>`
  border-radius: 6px;
  height: auto;
  width: 100%;
  background-color: white;
  position: relative;
  box-shadow: ${({ dropShadow }) => (dropShadow ? "0px 2px 8px 0px rgba(0, 0, 0, 0.3)" : "none")};
`;

export const ContentWrapper = styled.div`
  margin: 0 0px 16px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
`;
